/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_After_Delta_RemovedInputs */

const en_us2_workout_after_delta_removed = /** @type {(inputs: Workout_After_Delta_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 set fewer`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 set fewer`);
	return /** @type {LocalizedString} */ (`${i?.count} sets fewer`)
	
};

const pt_br2_workout_after_delta_removed = /** @type {(inputs: Workout_After_Delta_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série a menos`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série a menos`);
	return /** @type {LocalizedString} */ (`${i?.count} séries a menos`)
	
};

const es_419_workout_after_delta_removed = /** @type {(inputs: Workout_After_Delta_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie menos`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 serie menos`);
	return /** @type {LocalizedString} */ (`${i?.count} series menos`)
	
};

const pt_pt2_workout_after_delta_removed = /** @type {(inputs: Workout_After_Delta_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série a menos`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série a menos`);
	return /** @type {LocalizedString} */ (`${i?.count} séries a menos`)
	
};

const fr_fr2_workout_after_delta_removed = /** @type {(inputs: Workout_After_Delta_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série de moins`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série de moins`);
	return /** @type {LocalizedString} */ (`${i?.count} séries de moins`)
	
};

const de_de2_workout_after_delta_removed = /** @type {(inputs: Workout_After_Delta_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Satz weniger`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Satz weniger`);
	return /** @type {LocalizedString} */ (`${i?.count} Sätze weniger`)
	
};

const it_it2_workout_after_delta_removed = /** @type {(inputs: Workout_After_Delta_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie in meno`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 serie in meno`);
	return /** @type {LocalizedString} */ (`${i?.count} serie in meno`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 set fewer" |
* | "-1" | "1 set fewer" |
* | * | "{count} sets fewer" |
*
* @param {Workout_After_Delta_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_delta_removed = /** @type {((inputs: Workout_After_Delta_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Delta_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_delta_removed(inputs)
	if (locale === "es-419") return es_419_workout_after_delta_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_delta_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_delta_removed(inputs)
	if (locale === "de-DE") return de_de2_workout_after_delta_removed(inputs)
	if (locale === "it-IT") return it_it2_workout_after_delta_removed(inputs)
	return en_us2_workout_after_delta_removed(inputs)
});
export { workout_after_delta_removed as "workout-after.delta_removed" }